export default __webpack_public_path__ + "static/media/ciudad-activity8.968c5e75.jpg";